import { Accordion } from "react-bootstrap";
import PermissionListItem from "./PermissionListItem";

const PermissionsList = ({ list, type, level = [], theme }) => {
  return (
    <Accordion>
      {list.length > 0
        ? list.map((item, index) => (
            <PermissionListItem
              key={item._id}
              level={[...level]}
              index={index}
              type={type}
              element={item}
              theme={theme}
            />
          ))
        : null}
    </Accordion>
  );
};

export default PermissionsList;
